import React from "react";
import { getPosPlayerNameTeam } from "./PlayerName";

export default function PlayerImage({ player, pose, style }) {
  const playerName = getPosPlayerNameTeam(player);
  if (!player.nflTeamAbbr) return null;

  const isAnimated = pose.charAt(0) === "1";

  const nameParts = [player.nflTeamAbbr, pose];

  const isTeamDef = /team/.test(pose);
  if (!isTeamDef) {
    let skinTone =
      player.skinTone >= 4 || (player.skinTone === 0 && player.pos === "K")
        ? "light"
        : "dark";
    nameParts.push(skinTone);
  }
  if (isAnimated) nameParts.push("anim");

  const name = nameParts.join("_");

  return (
    <span title={playerName}>
      <img
        src={`/img/nfl/players/${name}.gif`}
        alt={playerName}
        style={style}
      />
    </span>
  );
}
